<ng-content select="[la-contextual-toolbar-left]"></ng-content>
<div class="spacer"></div>
<ng-content select="[la-contextual-toolbar-right]"></ng-content>
